// styles
import styled, { css } from 'styled-components';
// components
import LoadSpinner from 'components/LoadSpinner';

const SoFormButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 10px 12px 24px;
  gap: 8px;

  width: 100%;
  height: 40px;

  background: #0140cd;
  border-radius: 4px;

  flex: none;
  order: 1;
  flex-grow: 1;

  border: none;
  outline: none;

  /* 16px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  text-align: center;
  /* Flowkit/White */

  color: #ffffff;
  gap: 8px;
  cursor: pointer;

  svg {
    fill: var(--white);
    path {
      fill: var(--white);
    }
  }
  ${LoadSpinner} {
    transform: translateY(-7px);
  }
  ${(props) =>
    !!props.inverse &&
    css`
      background: var(--white);
      border: 1px solid var(--primary500);
      color: var(--primary500);
    `};

  ${(props) =>
    props.variant === 'small' &&
    css`
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    `};
`;

export default SoFormButton;
